/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * character object
 * @export
 * @interface PostUniverseIdsCharacter
 */
export interface PostUniverseIdsCharacter {
    /**
     * id integer
     * @type {number}
     * @memberof PostUniverseIdsCharacter
     */
    id?: number;
    /**
     * name string
     * @type {string}
     * @memberof PostUniverseIdsCharacter
     */
    name?: string;
}

/**
 * Check if a given object implements the PostUniverseIdsCharacter interface.
 */
export function instanceOfPostUniverseIdsCharacter(value: object): value is PostUniverseIdsCharacter {
    return true;
}

export function PostUniverseIdsCharacterFromJSON(json: any): PostUniverseIdsCharacter {
    return PostUniverseIdsCharacterFromJSONTyped(json, false);
}

export function PostUniverseIdsCharacterFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostUniverseIdsCharacter {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function PostUniverseIdsCharacterToJSON(json: any): PostUniverseIdsCharacter {
    return PostUniverseIdsCharacterToJSONTyped(json, false);
}

export function PostUniverseIdsCharacterToJSONTyped(value?: PostUniverseIdsCharacter | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

